import { useParams } from 'react-router-dom'
import { useProject } from '@/hooks'

interface ProjectSectionHeaderProps {
  sectionName: string
  children?: React.ReactNode
}

export function ProjectSectionHeader({ sectionName, children }: ProjectSectionHeaderProps) {
  const { projectId } = useParams()
  const { data: project } = useProject(projectId)

  return (
    <div className="flex items-start justify-between">
      <div className="-mt-2.5 ml-1">
        <p className="text-sm font-medium text-card-foreground">
          Project: {project?.name ?? 'Loading...'}
        </p>
        <h1 className="text-3xl font-bold">{sectionName}</h1>
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  )
}
